/*
 * Copyright (c) 2022. Revo Digital
 * ---
 * Author: gabriele
 * File: MyLabelLoginDialog.tsx
 * Project: mle-client-n
 * Committed last: 2022/5/26 @ 928
 * ---
 * Description:
 */

import { observer }                   from 'mobx-react';
import { Classes, Dialog }            from '@blueprintjs/core';
import classNames                     from 'classnames';
import { currentThemeIsDark }         from '../../../common/utils';
import { MyLabelLoginForm }           from '../../forms/MyLabelLoginForm';
import { BaseDialogProps, HasEditor } from '../../../common/props';

interface Props extends HasEditor, BaseDialogProps {
  onLoginSuccess: () => void;
}

export const MyLabelLoginDialog = observer((props: Props) => {
  return (<Dialog
    usePortal
    className={ classNames({ 'bp4-dark': currentThemeIsDark() }) }
    style={ { width: '20rem' } }
    isOpen={ props.isOpen }
    title="Accedi a MyLabel"
    onClose={ props.onClose }
    canOutsideClickClose={ false }
  >
    <div className={ Classes.DIALOG_BODY }>
      <div className="mb-2 text-bpgray-200">Inserisci le credenziali MyLabel per
        utilizzare le origini dati
      </div>
      <MyLabelLoginForm editor={ props.editor }
                        onLoginSuccessful={ props.onLoginSuccess }
                        onLoginError={ () => {} }
                        useFullSpace={ true }
      />
    </div>
  </Dialog>);
});